import React, { useState, useEffect } from "react"
import Modal from "react-modal"
import Select from "react-select"

import closeIcon from "../../assets/img/cross-icon.svg"
import { docModalStylesAdminDinamo } from "../utils/styles"
import { customStyles, SingleOption } from "../utils/utils"
import { displayLoader, hideLoader } from "../utils/windows"

const MovBodegaModal = ({
  displayModal,
  closeModal,
  data,
  selectedEds,
  selectedPagador,
  fecha,
  callServiceHandler,
  onSuccess,
}) => {

  const [destinos, setDestinos] = useState({})
  const [origenes, setOrigenes] = useState({})

  useEffect(() => {
    const initialDestinos = {}
    const initialOrigenes = {}
    if (data && data.length > 0) {
      data.forEach((item) => {
        if (item.tanque_origen) {
          initialOrigenes[item.id] = {
            label: item.tanque_origen,
            value: item.tanque_origen,
          }
        }
        if (item.tanque_destino) {
          initialDestinos[item.id] = {
            label: item.tanque_destino,
            value: item.tanque_destino,
          }
        }
      })
    }
    setDestinos(initialDestinos)
    setOrigenes(initialOrigenes)
  }, [data])

  const selectStylesMovBodega = {
    ...customStyles,
    menu: (provided, state) => ({
      ...provided,
      width: "180px",
      marginTop: "0"
    }),
    control: (base, state) => ({
      ...customStyles.control(base, state),
      width: "180px",
    }),
  }

  async function guardarMovBodega() {
    displayLoader()

    const url =
      process.env.REACT_APP_FLUCTUACIONES_API +
      "/fluctuaciones/leer-datos-cierre-dinamo"

    const movimientosActualizados = (data || [])
      .map((item) => {
        const origenSeleccionado = origenes[item.id]
          ? origenes[item.id].value
          : item.tanque_origen

        const destinoSeleccionado = destinos[item.id]
          ? destinos[item.id].value
          : item.tanque_destino

        // Solo considerar movimientos donde cambió tanque origen, tanque destino o ambos
        if (
          origenSeleccionado === item.tanque_origen &&
          destinoSeleccionado === item.tanque_destino
        ) {
          return null
        }

        return {
          id: item.id,
          tanqueOrigen: origenSeleccionado,
          tanqueDestino: destinoSeleccionado,
        }
      })
      .filter((mov) => mov !== null)

    const body = {
      ACCION: "ACTUALIZAR_MOVIMIENTOS_BODEGA",
      datos: {
        EDS: selectedEds?.value,
        PAGADOR: selectedPagador?.value,
        FECHA: fecha,
        movimientos_actualizados: movimientosActualizados,
      },
    }

    const result = await callServiceHandler(url, "POST", JSON.stringify(body))

    // DESCOMENTAR PARA PRUEBAS:: const result = { "data": { "mensaje": "Movimientos de bodega actualizados correctamente", "movimientos_actualizados": [ "14340" ], "detalle_cambios": [ { "id": "14340", "origen_actual": "4", "origen_nuevo": "FPVP95", "destino_actual": "FPVP95", "destino_nuevo": "FPVP95" } ], "historial_sk": "202509#761181#10075#20251202082142" }, "code": 200, "userMessage": "success" }

    hideLoader()

    if (result !== "error" && result?.code === 200)
      onSuccess(result.data.mensaje)
  }

  return (
    <Modal
      isOpen={displayModal}
      onRequestClose={closeModal}
      style={docModalStylesAdminDinamo()}
    >
      <button className="modal__close-btn" onClick={closeModal}>
        <img src={closeIcon} alt="close modal" />
      </button>

      <div className="documento-info-modal admin-dinamo-modal">
        <div className="title">Movimientos de Bodega</div>

        <div className="content">
          <table className="admin-dinamo-modal-table">
            <thead>
              <tr>
                <th>
                  ID MOV
                </th>
                <th>
                  Material
                </th>
                <th>
                  Tanque Origen
                </th>
                <th>
                  Salida Litros
                </th>
                <th>
                  Tanque Destino
                </th>
              </tr>
              <tr className="table-separator-row-border-top">
                <td colSpan="100%" />
              </tr>
            </thead>
            <tbody>
              {data?.map((item) => {
                const tanqueOptions = (item.opciones_tanques || []).map(
                  (tanque) => ({ label: tanque, value: tanque })
                )

                const selectedOrigen =
                  origenes[item.id] ||
                  tanqueOptions.find(
                    (opt) => opt.value === item.tanque_origen
                  )

                const selectedDestino =
                  destinos[item.id] ||
                  tanqueOptions.find(
                    (opt) => opt.value === item.tanque_destino
                  )

                return (
                  <tr className="data" key={item.id}>
                    <td>
                      {item.id || "-"}
                    </td>
                    <td>
                      {item.material || "-"}
                    </td>
                    <td className="align-right">
                      <Select
                        className="eds-select"
                        value={selectedOrigen}
                        onChange={(e) =>
                          setOrigenes({
                            ...origenes,
                            [item.id]: e,
                          })
                        }
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        options={tanqueOptions}
                        components={{
                          SingleOption,
                          IndicatorSeparator: () => null,
                        }}
                        isClearable={false}
                        autosize={false}
                        placeholder="Seleccionar"
                        styles={selectStylesMovBodega}
                      />
                    </td>
                    <td className="align-right">
                      {item.litros || "-"}
                    </td>
                    <td className="align-right">
                      <Select
                        className="eds-select"
                        value={selectedDestino}
                        onChange={(e) =>
                          setDestinos({
                            ...destinos,
                            [item.id]: e,
                          })
                        }
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        options={tanqueOptions}
                        components={{
                          SingleOption,
                          IndicatorSeparator: () => null,
                        }}
                        isClearable={false}
                        autosize={false}
                        placeholder="Seleccionar"
                        styles={selectStylesMovBodega}
                      />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          <button className="main-button" onClick={guardarMovBodega}>Guardar</button>
        </div>
      </div>
    </Modal>
  )
}

export default MovBodegaModal
